export default "__VITE_ASSET__db69f2c3__"